import { render } from "./AddressList.vue?vue&type=template&id=582852a8&scoped=true"
import script from "./AddressList.vue?vue&type=script&lang=js"
export * from "./AddressList.vue?vue&type=script&lang=js"

import "./AddressList.vue?vue&type=style&index=0&id=582852a8&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582852a8"],['__file',"src/assets/js/pages/Gate/AddressList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "582852a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('582852a8', __exports__)) {
    api.reload('582852a8', __exports__)
  }
  
  module.hot.accept("./AddressList.vue?vue&type=template&id=582852a8&scoped=true", () => {
    api.rerender('582852a8', render)
  })

}


export default __exports__